<template>
  <div class="home-container">
    <div class="chart-grid">
      <!-- 图表1：日下单量趋势 -->
      <div class="chart-card">
        <div class="chart-header">
          <span class="chart-title">📊 日下单量趋势</span>
          <el-select
            v-model="orderDaytype"
            size="mini"
            @change="handleOrderDayChange"
            style="width: 90px"
          >
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="chart-body">
          <div ref="chartOrder" class="chart-box"></div>
        </div>
      </div>

      <!-- 图表2：服务项目排行 -->
      <div class="chart-card">
        <div class="chart-header">
          <span class="chart-title">🏆 服务项目排行</span>
          <el-select
            v-model="serviceDaytype"
            size="mini"
            @change="handleServiceDayChange"
            style="width: 90px"
          >
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="chart-body">
          <div ref="chartService" class="chart-box"></div>
        </div>
      </div>

      <!-- 图表3：营收趋势 -->
      <div class="chart-card">
        <div class="chart-header">
          <span class="chart-title">💰 营收趋势</span>
          <el-select
            v-model="amountDaytype"
            size="mini"
            @change="handleAmountDayChange"
            style="width: 90px"
          >
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="chart-body">
          <div ref="chartAmount" class="chart-box"></div>
        </div>
      </div>

      <!-- 图表4：服务商数据汇总 -->
      <div class="chart-card">
        <div class="chart-header">
          <span class="chart-title">📋 服务商数据汇总</span>
        </div>
        <div class="chart-body summary-body">
          <div class="summary-grid">
            <div class="summary-item">
              <span class="summary-label">今日订单金额</span>
              <span class="summary-value"
                >¥{{ homeData.orderAmount || 0 }}</span
              >
            </div>
            <div class="summary-item">
              <span class="summary-label">今日实收金额</span>
              <span class="summary-value"
                >¥{{ homeData.receivedAmount || 0 }}</span
              >
            </div>
            <div class="summary-item">
              <span class="summary-label">本月实收金额</span>
              <span class="summary-value"
                >¥{{ homeData.monthReceivedAmount || 0 }}</span
              >
            </div>
            <div class="summary-item">
              <span class="summary-label">上月同期营收</span>
              <span class="summary-value"
                >¥{{ homeData.lastMonthReceivedAmount || 0 }}</span
              >
            </div>
            <div class="summary-item summary-highlight">
              <span class="summary-label">环比增减</span>
              <span
                class="summary-value"
                :class="getPercentClass(homeData.monthOnMonthPercentage)"
              >
                <i :class="getPercentIcon(homeData.monthOnMonthPercentage)"></i>
                {{ formatPercent(homeData.monthOnMonthPercentage) }}
              </span>
            </div>
            <div class="summary-item">
              <span class="summary-label">待结算金额</span>
              <span class="summary-value">¥{{ homeData.waitAmount || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  GetComHomeDailyOrderCount,
  GetComHomeServiceTop,
  GetComHomeDailyAmount,
  GetComHomeData,
} from "@/api/home";

export default {
  name: "Home",
  data() {
    return {
      orderDaytype: 1,
      serviceDaytype: 3,
      amountDaytype: 1,
      typeOption: [
        { value: 1, label: "近7天" },
        { value: 2, label: "近一月" },
        { value: 3, label: "近一年" },
      ],
      dailyOrderCount: {},
      serviceTop: {},
      dailyAmount: {},
      homeData: {},
      chartOrder: null,
      chartService: null,
      chartAmount: null,
    };
  },
  mounted() {
    this.getDailyOrderCount();
    this.getServiceTop();
    this.getDailyAmount();
    this.getHomeData();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.disposeCharts();
  },
  methods: {
    getDailyOrderCount() {
      GetComHomeDailyOrderCount({ daytype: this.orderDaytype }).then((res) => {
        if (res.data.isSuccess) {
          this.dailyOrderCount = res.data.data || {};
          this.$nextTick(() => this.initChartOrder());
        }
      });
    },
    getServiceTop() {
      GetComHomeServiceTop({ daytype: this.serviceDaytype }).then((res) => {
        if (res.data.isSuccess) {
          this.serviceTop = res.data.data || {};
          this.$nextTick(() => this.initChartService());
        }
      });
    },
    getDailyAmount() {
      GetComHomeDailyAmount({ daytype: this.amountDaytype }).then((res) => {
        if (res.data.isSuccess) {
          this.dailyAmount = res.data.data || {};
          this.$nextTick(() => this.initChartAmount());
        }
      });
    },
    getHomeData() {
      GetComHomeData().then((res) => {
        if (res.data.isSuccess) {
          this.homeData = res.data.data || {};
        }
      });
    },

    initChartOrder() {
      const { xAxisData, orderCount } = this.dailyOrderCount;
      if (!xAxisData || !xAxisData.length) return;
      this.disposeChart("chartOrder");
      const chartDom = this.$refs.chartOrder;
      if (!chartDom) return;
      this.chartOrder = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#e8eaed",
          borderWidth: 1,
          textStyle: { fontSize: 12, color: "#1d2129" },
          formatter: (params) => {
            const p = params[0];
            return `下单量：${p.value} 单`;
          },
        },
        grid: {
          left: "6%",
          right: "6%",
          top: "14%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLine: { lineStyle: { color: "#e8eaed" } },
          axisLabel: { color: "#86909c", fontSize: 10, rotate: 20 },
          axisTick: { alignWithLabel: true },
          splitLine: { show: false },
        },
        yAxis: {
          type: "value",
          name: "单数",
          nameTextStyle: { color: "#86909c", fontSize: 10 },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#86909c", fontSize: 10 },
          splitLine: { lineStyle: { color: "#f0f2f5", type: "dashed" } },
        },
        series: [
          {
            type: "line",
            data: orderCount || [],
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            lineStyle: { width: 2, color: "#5B8FF9" },
            itemStyle: { color: "#5B8FF9" },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(91,143,249,0.25)" },
                { offset: 1, color: "rgba(91,143,249,0.02)" },
              ]),
            },
          },
        ],
      };
      this.chartOrder.setOption(option);
      this.chartOrder.resize();
    },

    initChartService() {
      const { xAxisData, orderCount } = this.serviceTop;
      if (!xAxisData || !xAxisData.length) return;
      this.disposeChart("chartService");
      const chartDom = this.$refs.chartService;
      if (!chartDom) return;
      this.chartService = echarts.init(chartDom);
      const names = xAxisData.slice(0, 10);
      const values = orderCount.slice(0, 10);
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#e8eaed",
          borderWidth: 1,
          textStyle: { fontSize: 12, color: "#1d2129" },
          formatter: (params) => {
            const p = params[0];
            return `<strong>${p.name}</strong><br/>下单量：${p.value} 单`;
          },
        },
        grid: {
          left: "12%",
          right: "10%",
          top: "8%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: "单数",
          nameTextStyle: { color: "#86909c", fontSize: 10 },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#86909c", fontSize: 10 },
          splitLine: { lineStyle: { color: "#f0f2f5", type: "dashed" } },
        },
        yAxis: {
          type: "category",
          data: names,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: "#4e5969",
            fontSize: 11,
            width: 70,
            overflow: "truncate",
          },
        },
        series: [
          {
            type: "bar",
            data: values,
            barWidth: "12",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#5B8FF9" },
                { offset: 1, color: "#5AD8A6" },
              ]),
              borderRadius: [0, 4, 4, 0],
            },
            label: {
              show: true,
              position: "right",
              fontSize: 10,
              color: "#86909c",
            },
          },
        ],
      };
      this.chartService.setOption(option);
      this.chartService.resize();
    },

    initChartAmount() {
      const { xAxisData, companyIncome } = this.dailyAmount;
      if (!xAxisData || !xAxisData.length) return;
      this.disposeChart("chartAmount");
      const chartDom = this.$refs.chartAmount;
      if (!chartDom) return;
      this.chartAmount = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#e8eaed",
          borderWidth: 1,
          textStyle: { fontSize: 12, color: "#1d2129" },
          formatter: (params) => {
            const p = params[0];
            return `<strong>${p.axisValue}</strong><br/>营收：¥${p.value}`;
          },
        },
        grid: {
          left: "6%",
          right: "6%",
          top: "14%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLine: { lineStyle: { color: "#e8eaed" } },
          axisLabel: { color: "#86909c", fontSize: 10, rotate: 20 },
          axisTick: { alignWithLabel: true },
          splitLine: { show: false },
        },
        yAxis: {
          type: "value",
          name: "金额(元)",
          nameTextStyle: { color: "#86909c", fontSize: 10 },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: "#86909c",
            fontSize: 10,
            formatter: (val) => {
              if (val >= 10000) return (val / 10000).toFixed(1) + "w";
              return val;
            },
          },
          splitLine: { lineStyle: { color: "#f0f2f5", type: "dashed" } },
        },
        series: [
          {
            type: "line",
            data: companyIncome || [],
            smooth: true,
            symbol: "diamond",
            symbolSize: 8,
            lineStyle: { width: 2, color: "#F6BD16" },
            itemStyle: { color: "#F6BD16" },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(246,189,22,0.25)" },
                { offset: 1, color: "rgba(246,189,22,0.02)" },
              ]),
            },
          },
        ],
      };
      this.chartAmount.setOption(option);
      this.chartAmount.resize();
    },

    formatPercent(val) {
      if (val === undefined || val === null) return "0%";
      const num = Number(val);
      if (isNaN(num)) return "0%";
      return (num > 0 ? "+" : "") + num.toFixed(2) + "%";
    },
    getPercentClass(val) {
      if (val === undefined || val === null) return "";
      const num = Number(val);
      if (isNaN(num)) return "";
      if (num > 0) return "percent-up";
      if (num < 0) return "percent-down";
      return "percent-zero";
    },
    getPercentIcon(val) {
      if (val === undefined || val === null) return "";
      const num = Number(val);
      if (isNaN(num)) return "";
      if (num > 0) return "el-icon-top";
      if (num < 0) return "el-icon-bottom";
      return "";
    },

    disposeChart(refName) {
      const map = {
        chartOrder: "chartOrder",
        chartService: "chartService",
        chartAmount: "chartAmount",
      };
      const key = map[refName];
      if (key && this[key]) {
        this[key].dispose();
        this[key] = null;
      }
    },
    disposeCharts() {
      ["chartOrder", "chartService", "chartAmount"].forEach((key) => {
        if (this[key]) {
          this[key].dispose();
          this[key] = null;
        }
      });
    },
    handleResize() {
      ["chartOrder", "chartService", "chartAmount"].forEach((key) => {
        if (this[key]) {
          this[key].resize();
        }
      });
    },
    handleOrderDayChange() {
      this.getDailyOrderCount();
    },
    handleServiceDayChange() {
      this.getServiceTop();
    },
    handleAmountDayChange() {
      this.getDailyAmount();
    },
  },
};
</script>

<style scoped>
/* ===== 全局容器 ===== */
.home-container {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* ===== 图表网格 ===== */
.chart-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

/* ===== 卡片 ===== */
.chart-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: box-shadow 0.25s ease, transform 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.02);
  border: 1px dashed #e2e2e2;
}

/* .chart-card:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
} */

/* ===== 卡片头部 ===== */
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  flex-shrink: 0;
  height: 48px; /* 固定高度，确保所有卡片一致 */
  min-height: 48px;
  border-bottom: 1px dashed #e2e2e2;
}

.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  letter-spacing: 0.3px;
}

.chart-title i {
  margin-right: 6px;
}

/* 下拉框使用默认样式，不做自定义 */

/* ===== 卡片主体 ===== */
.chart-body {
  flex: 1;
  padding: 8px 12px 12px 12px;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.chart-box {
  width: 100%;
  height: 100%;
  min-height: 200px;
  flex: 1;
}

/* ===== 图四：汇总指标 ===== */
.summary-body {
  padding: 12px 16px 16px 16px;
  justify-content: center;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  width: 100%;
}

.summary-item {
  background: #f7f9fc;
  border-radius: 10px;
  padding: 12px 10px;
  text-align: center;
  border: 1px solid #f0f2f5;
  transition: background 0.2s ease;
}

.summary-item:hover {
  background: #eef2f7;
}

.summary-item .summary-label {
  display: block;
  font-size: 12px;
  color: #86909c;
  margin-bottom: 4px;
  font-weight: 400;
}

.summary-item .summary-value {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.summary-highlight {
  background: linear-gradient(135deg, #f7f9fc 0%, #f0f2f5 100%);
  border-color: #e8eaed;
}

.summary-highlight .summary-value {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.summary-highlight .summary-value i {
  font-size: 14px;
}

/* 环比颜色 */
.percent-up {
  color: #f53f3f !important;
}
.percent-down {
  color: #00b42a !important;
}
.percent-zero {
  color: #86909c !important;
}

/* ===== 响应式 ===== */
@media (max-width: 1200px) {
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1024px) {
  .chart-grid {
    gap: 14px;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 12px;
    height: auto;
    min-height: calc(100vh - 60px);
  }
  .chart-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .chart-card {
    min-height: 280px;
  }
  .chart-box {
    min-height: 200px;
  }
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }
  .chart-title {
    font-size: 14px;
  }
  .chart-header {
    padding: 10px 16px;
    height: 44px;
    min-height: 44px;
  }
}

@media (max-width: 480px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .summary-item .summary-value {
    font-size: 16px;
  }
  .summary-highlight .summary-value {
    font-size: 18px;
  }
}
</style>
